<script>
	import {onMount} from 'svelte'

	// const API_KEY = 'bb229e060fb346ca9eb1eb0c60e6a597'
	// const URL = 'https://newsapi.org/v2/everything?q="Slash production"&from=2021-07-20to=2021-08-21&language=en&sortBy=publishedAt&apiKey=bb229e060fb346ca9eb1eb0c60e6a597'
	const URL = 'https://saurav.tech/NewsAPI/everything/cnn.json'
	let articles = [];

	onMount(async function() {
		const response = await fetch(URL);
		const json = await response.json();
		articles = json["articles"];
	})
</script>

<main>
	<h1 class='headline'>CNN</h1>
	<div class='container'>
		{#each articles as article}
			<div class="card">
				<img src='{article.urlToImage}' alt=''>
				<div class="card-body">
					<h3>{article.title}</h3>
					<p>{article.description}</p>
					<a href='{article.url}' target='blank'>Read story</a> -->
				</div>
			</div>
		{/each}
	</div>
</main>

<style>

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	.headline {
		text-align: center;
	}

	.container {
		display:grid;
		grid-template-columns: repeat(auto-fill, minmax(305px, 1fr));
		grid-gap: 10px;
	}

	.container > .card img {
		max-width: 100%;
	}
	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	} 
</style>